<template>
  <span>
    <span :title="username" class="username" :style="`max-width: ${mw}`"><small v-if="!the_img" class="fa-circle" :class="{ 'fa text-success': isOnline, 'fal text-insignificant': !isOnline, [offlineCls]: !isOnline }"></small><small v-if="the_img"><img :src="the_img" :alt="username" style="width: 20px; border-radius: 100px;"></small>&nbsp;<span v-html="username"></span></span>
    <span class="clearfix"></span>
  </span>
</template>

<script>
import { mapGetters } from 'vuex';

// @ is an alias to /src
export default {
  name: 'username',
  props: ['uid', 'img', 'username', 'offlineClass', 'maxWidth'],
  computed: {
    ...mapGetters(['isLoggedIn', 'getCurrentUser', 'getUserData', 'getPresence']),
    mw() {
      if (!this.maxWidth) {
        return 'none';
      }

      return this.maxWidth;
    },
    the_img() {
      return this.img;
    },
    offlineCls() {
      if (!this.offlineClass) {
        return 'fal text-insignificant';
      }

      return `${this.offlineClass} fal text-insignificant`;
    },
    isOnline() {
      if (!this.getPresence) {
        return false;
      }

      if (!this.uid) {
        return false;
      }

      if (!this.getPresence[this.uid]) {
        return false;
      }

      return this.getPresence[this.uid].connections;
    },
  },
};
</script>

<style lang="scss" scoped>
  .username {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    display: inline-block;
    display: table-cell;
    float: left;
    margin-right: 5px;
  }
</style>
